module.exports = __webpack_public_path__ + "img/avatar1.c8ef3aa2.png";